import React from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchUsers, assignCourier } from "api";
import { Modal, Spinner, EmptyState } from "components/common";
import type { ScheduleItem, ContactUser } from "types";

export function AssignCourierModal({
  item,
  partnerName,
  onClose,
  onSuccess,
}: {
  item:        ScheduleItem;
  partnerName: string;
  onClose:     () => void;
  onSuccess:   () => void;
}) {
  const { data: users = [], isLoading } = useQuery({
    queryKey: ["users"],
    queryFn:  () => fetchUsers(),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: (courierId: number) => assignCourier(item.id, courierId),
    onSuccess,
  });

  const activeCouriers = users.filter((u: ContactUser) => u.active && u.role === "bridge13_courier");

  return (
    <Modal title={`Assign courier — ${partnerName}`} onClose={onClose}>
      {isLoading ? (
        <Spinner className="py-8" />
      ) : activeCouriers.length === 0 ? (
        <EmptyState message="No active couriers available." />
      ) : (
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {activeCouriers.map((u: ContactUser) => (
            <button
              key={u.id}
              onClick={() => mutate(u.id)}
              disabled={isPending}
              className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors hover:bg-gray-50 flex items-center justify-between ${
                item.contact_user_id === u.id ? "bg-brand-50 text-brand-700" : "text-gray-700"
              }`}
            >
              <span>{u.name_1}{u.name_2 ? ` ${u.name_2}` : ""}</span>
              {item.contact_user_id === u.id && (
                <span className="text-xs text-brand-500">Current</span>
              )}
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
}
